import { ReactElement } from "react";
import { INiche } from "@/common/services/types";
import { NichePreview } from "components/niches/NichePreview/NichePreview";
import { useFollowNicheQueries } from "@/common/hooks/useFollowNicheQueries";

interface INicheCatalogItem {
  niche: INiche;
  following: boolean;
  onFollow: (id: string, status: boolean) => void;
  isLink?: boolean;
  withPreview?: boolean;
  visibility?: boolean;
}

export const NicheCatalogItem = ({
  niche,
  following,
  onFollow: sendFollowState,
  withPreview,
  isLink
}: INicheCatalogItem): ReactElement => {
  const { onFollowAction } = useFollowNicheQueries({ nicheId: niche.id, following, sendFollowState });

  return (
    <NichePreview
      niche={niche}
      following={following}
      isLink={isLink}
      withPreview={withPreview}
      onFollow={onFollowAction}
    />
  );
};
